import React from 'react';
import { Link, Img } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { UFL_DOMAIN_EXT, UFL_ENVIRONMENT, isProd } from 'utils';

const SiteLogo = () => {
  const { t } = useTranslation();
  const homeURL = isProd
    ? `https://twomenandatruck.${UFL_DOMAIN_EXT}`
    : `https://brand-d8-${UFL_ENVIRONMENT}.twomenbeta.${UFL_DOMAIN_EXT}`;

  return (
    <Link
      id="logo"
      href={homeURL}
      target="_blank"
      rel="noopener"
      display="flex"
      alignItems="center"
      ml={{ base: 'auto', md: 4 }}
      mr="auto"
      transition="all 0.2s ease"
      width="100%"
      maxWidth="275px"
      height="100%"
    >
      <Img
        src="/img/logo-black-one-line.svg"
        alt={t('TWO MEN AND A TRUCK')}
        fetchPriority="high"
        loading="eager"
        htmlWidth="275"
        htmlHeight="34"
        width="100%"
        height="auto"
        display="block"
        _dark={{ filter: 'invert(1)' }}
      />
    </Link>
  );
};

export default SiteLogo;
